import { AutocompleteInput, ReferenceInput } from "react-admin";

import React from "react";

const MirCodeInput = (props) => (
  <ReferenceInput {...props} reference="user-outputs/mir-codes">
    <AutocompleteInput optionText="name" />
  </ReferenceInput>
);

export default MirCodeInput;
